/**
 * L-system presets for LSystemNode
 *
 * Reference: src/plugins/generative/sketch/lsystem/lsystem.html
 */

import type { Preset } from '@/nodes/PresetManager';

export const LSYSTEM_PRESETS: Preset[] = [
  {
    name: 'Koch Curve',
    description: 'Quadratic Koch curve',
    params: {
      axiom: 'F',
      angle: 90,
      steps: { value: 3, max: 6 },
      F: 'F-F+F+F-F'
    }
  },
  {
    name: 'Koch Snowflake',
    description: 'Koch snowflake (60° triangular)',
    params: {
      axiom: 'F++F++F',
      angle: 60,
      steps: { value: 4, max: 7 },
      F: 'F-F++F-F'
    }
  },
  {

    
    name: 'Hilbert Curve',
    description: 'Space-filling Hilbert curve',
    params: {
      axiom: 'L',
      angle: 90,
      steps: { value: 3, max: 7 },
      L: '+RF-LFL-FR+',
      R: '-LF+RFR+FL-'
    }
  },
  {
    name: 'Sierpinski Triangle',
    description: 'Sierpinski triangle fractal',
    params: {
      axiom: 'F-G-G',
      angle: 120,
      steps: { value: 4, max: 8 },
      F: 'F-G+F+G-F',
      G: 'GG'
    }
  },
  {
    name: 'Sierpinski Arrowhead',
    description: 'Sierpinski arrowhead curve',
    params: {
      axiom: 'A',
      angle: 60,
      steps: { value: 4, max: 9 },
      A: 'B-A-B',
      B: 'A+B+A'
    }
  },
  {
    name: 'Dragon Curve',
    description: 'Dragon curve fractal',
    params: {
      axiom: 'FX',
      angle: 90,
      steps: { value: 6, max: 14 },
      X: 'X+YF+',
      Y: '-FX-Y'
    }
  },
  {
    name: 'Gosper Curve',
    description: 'Gosper flowsnake curve',
    params: {
      axiom: 'A',
      angle: 60,
      steps: { value: 3, max: 5 },
      A: 'A-B--B+A++AA+B-',
      B: '+A-BB--B-A++A+B'
    }
  },
  {
    name: 'Lévy C Curve',
    description: 'Lévy C curve fractal',
    params: {
      axiom: 'F',
      angle: 45,
      steps: { value: 6, max: 14 },
      F: '+F--F+'
    }
  },
  {
    name: 'Penrose Tiling',
    description: 'Penrose aperiodic tiling',
    params: {
      axiom: '[7]++[7]++[7]++[7]++[7]',
      angle: 36,
      steps: { value: 3, max: 6 },
      6: '8F++9F----7F[-8F----6F]++',
      7: '+8F--9F[---6F--7F]+',
      8: '-6F++7F[+++8F++9F]-',
      9: '--8F++++6F[+9F++++7F]--7F',
      F: ''
    }
  },
  {
    name: 'Simple Plant',
    description: 'Organic branching plant',
    params: {
      axiom: 'X',
      angle: 25,
      steps: { value: 4, max: 7 },
      X: 'F+[[X]-X]-F[-FX]+X',
      F: 'FF'
    }
  },
  {
    name: 'Weed',
    description: 'Weed-like plant',
    params: {
      axiom: 'X',
      angle: 25,
      steps: { value: 3, max: 7 },
      X: 'F-[[X]+X]+F[+FX]-X',
      F: 'FF'
    }
  },
  {
    name: 'Bush',
    description: 'Bushy plant with branching',
    params: {
      axiom: 'F',
      angle: 22.5,
      steps: { value: 3, max: 5 },
      F: 'FF+[+F-F-F]-[-F+F+F]'
    }
  },
  {
    name: 'Fractal Tree',
    description: 'Symmetric branching tree',
    params: {
      axiom: 'X',
      angle: 30,
      steps: { value: 4, max: 7 },
      X: 'F[+X][-X]FX',
      F: 'FF'
    }
  },
  {
    name: 'Tree 3D',
    description: '3D tree with multiple branches',
    params: {
      axiom: 'F',
      angle: 10,
      steps: { value: 4, max: 5 },
      F: 'Y[++++++MF][-----NF][^^^^^OF][&&&&&PF]',
      M: 'G-M',
      N: 'G+N',
      O: 'G&O',
      P: 'G^P',
      Y: 'G-GY+',
      G: 'GG'
    }
  },
  {
    name: 'Simple Plant 3D',
    description: '3D plant with multiple branch directions',
    params: {
      axiom: 'G',
      angle: 30,
      steps: { value: 3, max: 5 },
      F: 'FF',
      G: 'F[+&G][+^G][+>G][+>&G][-&G][-^G][->G][->&G]-G'
    }
  },
  {
    name: 'Hilbert 3D',
    description: '3D space-filling Hilbert curve',
    params: {
      axiom: 'X',
      angle: 90,
      steps: { value: 3, max: 4 },
      X: '^<XF^<XFX-F^>>XFX&F+>>XFX-F>X->'
    }
  }
];
